export const sleep = (timeout) => {
  return new Promise((resolve) => setTimeout(resolve, timeout));
};
